import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '2023重庆市深化“小萝卜头”进校园活动';
const baseUrl = 'XLBT0911';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/pathold/home`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    // { 这是海报用的路由
    //   path: 'pathold/home',
    //   name: `${baseUrl}-welcome`,
    //   component: () => import('./Home.vue'),
    //   meta: {
    //     title: PAGE_TITLE,
    //     rank: 1,
    //   },
 

    // {这是活动用的路由
    //       path: 'pathold/home',
    //       name: `${baseUrl}-home`,
    //       component: () => import('./pages/Welcome.vue'),
    //       meta: {
    //         title: PAGE_TITLE,
    //         rank: 1,
    //       },
    //     },
    {
          path: 'pathold/home',
          name: `${baseUrl}-listPage`,
          component: () => import('./pages/ListPage.vue'),
          meta: {
            title: PAGE_TITLE,
            rank: 1,
             keepPosition: true,
          },
        },
        {
          path: 'news',
          name: `${baseUrl}-news`,
          component: () => import('./pages/News.vue'),
          meta: {
            title: PAGE_TITLE,
          },
        },
        {
          path: 'rules',
          name: `${baseUrl}-rules`,
          component: () => import('./pages/Rules.vue'),
          meta: {
            title: PAGE_TITLE,
          },
        },
        {
          path: 'rank',
          name: `${baseUrl}-rank`,
          component: () => import('./pages/Rank.vue'),
          meta: {
            title: PAGE_TITLE,
          },
        },
        {
          path: 'pathold/detail',
          name: `${baseUrl}-detail`,
          component: () => import('./pages/Detail.vue'),
          meta: {
            title: PAGE_TITLE,
            rank: 2,
            keepPosition: true,
          },
        },
        {
          path: 'pathold/register',
          name: `${baseUrl}-register`,
          component: () => import('./pages/Register.vue'),
          meta: {
            title: PAGE_TITLE,
            rank: 3,
          },
        },
        {
          path: 'pathold/user',
          name: `${baseUrl}-user`,
          component: () => import('./pages/User.vue'),
          meta: {
            title: PAGE_TITLE,
          },
        },
  ]
  
};

export default route;
